import PropTypes from 'prop-types'
import { Link, StaticQuery, graphql } from "gatsby";
import {
    Trans,
    useTranslation,
    useI18next,
    language,
} from "gatsby-plugin-react-i18next";
import React, { useEffect } from 'react';

const LayoutMeta = ({ data,  bodyclassName, location }) => {
    const site = data.allGhostSettings.edges[0].node;
    const { defaultLanguage, language, originalPath, changeLanguage } =
        useI18next();
    useEffect(() => {
        if (typeof document !== 'undefined') {
            const storedLanguage = localStorage.getItem('gatsby-i18next-language') || language;
            document.documentElement.lang = storedLanguage;
        }
        }, [language]);
  return (
    <>
         {/* <html lang={site.lang} /> */}
         {/* <html lang={language} /> */}
                <style type="text/css">{`${site.codeinjection_styles}`}</style>
                <script type="text/javascript">
                    {`
                        (function() {
                            function async_loads(){
                                var s = document.createElement('script'); s.type = 'text/javascript';
                                s.src = ('https:' == document.location.protocol ? 'https://js' : 'http://js') + '.hs-scripts.com/6153052.js';
                                var c = document.getElementsByTagName('script')[0]; c.parentNode.insertBefore(s, c);
                            }
                            if(window.attachEvent) { window.attachEvent('onload', async_loads); }
                            else { window.addEventListener('load', async_loads, false); }
                        })();
                    `}
                </script>
                <body className={bodyclassName} />
    </>
  )
}

LayoutMeta.propTypes = {
    children: PropTypes.node.isRequired,
    bodyclassName: PropTypes.string,
    isHome: PropTypes.bool,
    data: PropTypes.shape({
        file: PropTypes.object,
        allGhostSettings: PropTypes.object.isRequired,
    }).isRequired,
};

const LayoutMetaSettingsQuery = (props) => (
    <StaticQuery
        query={graphql`
            query GhostSettings {
                allGhostSettings {
                    edges {
                        node {
                            ...GhostSettingsFields
                        }
                    }
                }
            }
        `}
        render={(data) => <LayoutMeta data={data} {...props} />}
    />
);

export default LayoutMetaSettingsQuery
